import styled from "styled-components";
import { Label } from "@sonder/ui/source/styled/fragments/Label";

export const LoginErrorMessage = styled(Label)`
  visibility: ${props => (props.error ? "visible" : "hidden")};
  margin-bottom: 1rem;
`;
